import { Meta, Story } from '@storybook/react';
import { TravelStep, TravelStepProps } from './TravelStep';
export default {
	title: 'Calculators/TravelDeduction/Steps/TravelStep',
	component: TravelStep,
} as Meta;

const Template: Story<TravelStepProps> = (args: TravelStepProps) => <TravelStep {...args} />;

export const Default: Story<TravelStepProps> = Template.bind({});
Default.args = {
	distance: {
		label: 'Afstand fra min hjemmeadresse til arbejde og retur (km pr. dag)',
		helpText:
			'<p> Du skal bruge den reelle kørselsafstand mellem din officielle adresse (folkeregister-adresse) og din arbejdsplads. Det behøver ikke være den korteste rute. </p><p> Hvis du kører i tog eller bus, er det stadig normalafstanden i bil, der gælder. Hvis du har afstikkere på din rute (henter kollegaer eller henter/bringer børn), skal du ikke regne de ekstra kilometer med. </p>',
		helpTextTitle: 'Info vedr. afstand',
		placeholder: 'Skriv afstand pr. dag',
	},
	year: { label: 'Vælg år' },
	yearValues: [
		{ label: '2024', value: '2024' },
		{ label: '2025', value: '2025' },
	],
	startDate: {
		label: 'Startdato',
		placeholder: 'Startdato',
	},
	endDate: {
		label: 'Slutdato',
		placeholder: 'Slutdato',
	},
	averageWorkingDays: {
		label: 'Arbejdsdage i perioden i gennemsnit',
		placeholder: 'Arbejdsdage i perioden i gennemsnit',
		helpTextTitle: 'Antal arbejdsdage',
		helpText:
			'<p>Antallet af arbejdsdage er beregnet efter den periode, du har valgt. Der er i gennemsnit 180 arbejdsdag på et år, hvor der er kørsel mellem hjem og arbejde. Ved din beregning skal du tage hensyn til fx ferie, hjemmearbejdsdage, sygdom og kursus.</p>',
	},
	workingDaysWithTransport: {
		label: 'Mine arbejdsdage med transport i perioden',
		helpTextTitle: 'Arbejdsdage med transport i perioden',
		helpText:
			'<p> Du får kun fradrag for de arbejdsdage i perioden, hvor du reelt er kørt til og fra arbejde. Du kan altså ikke få fradrag for fx fridage, hjemmearbejdsdage, kursusdage, sygedage, orlov, barns sygedage eller andre dage, hvor du ikke har haft transport. </p>',

		placeholder: 'Skriv antal',
	},
	units: {
		days: 'dage',
		kilometers: 'km',
	},
	datePickerAriaLabels: {
		prevBtnAriaLabel: 'Forrige måned',
		nextBtnAriaLabel: 'Næste måned',
	},
};
